import { put, call, take, fork } from 'redux-saga/effects'
import { AICreatorGetDocumentHeadersService } from '../../api/ai-creator'
import { GET_DOCUMENT_HEADERS } from '../../reducers/ai-creator/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* getDocumentHeadersFlow(payload) {
  try {
    const { outlineId, callback } = payload
    const response = yield call(AICreatorGetDocumentHeadersService, outlineId)
    callback(response)

    yield put(operationSuccess())
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* getDocumentHeadersWatcher() {
  while (true) {
    const action = yield take(GET_DOCUMENT_HEADERS)
    const { payload } = action

    yield fork(generalSaga, getDocumentHeadersFlow, payload)
  }
}
